import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper'
import Button from 'material-ui/Button'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import InputParticipants from './InputParticipants'
import InputContactData from './InputContactData'
// import ChooseRegistryOption from './ChooseRegistryOptions'
import List, { ListItem, ListItemText, /* ListItemIcon */ } from 'material-ui/List'
import ChooseOptions from './ChooseOptions'
import ChooseHotels from './ChooseHotels'
import ChooseDates from './ChooseDates'
import StartingInfo from './StartingInfo'
import EndingInfo from './EndingInfo'
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import Phone from 'material-ui-icons/Phone'
import Email from 'material-ui-icons/Email'

const styles = theme => ({
  root: {
    maxWidth: 780,
    // width: '90%',
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  actionsContainer: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  resetContainer: {
    marginTop: 0,
    padding: theme.spacing.unit * 3, // TODO: See TODO note on Stepper
  },
  info: {
    textAlign: 'justify',
  },
  icon: {
    position: 'relative',
    width: 16,
    height: 16,
    top: 4,
    marginRight: 3,
  },
  list: {
    // textAling: 'left',
    // width: '100%',
    // maxWidth: 360,
    // backgroundColor: theme.palette.background.paper,
    // backgroundColor: 'red',
  }
});

function getSteps (withHotel) {
  if (withHotel) {
    return ['Información previa', 'Datos de contacto', 'Turno de competición', 'Paquete de inscripción', 'Número de integrantes', 'Opciones de alojamiento', 'Confirmar']
  }
  else {
    return ['Información previa', 'Datos de contacto', 'Turno de competición', 'Paquete de inscripción', 'Número de integrantes', 'Confirmar']
  }
}

class VerticalLinearStepper extends React.Component {
  state = {
    activeStep: 0,
    form: {
      participants:{
        staff:1,
        players:15,
      },
      hotel: {
        name: 'Sin hotel',
        price: 0,
      }

    },
    currentOption: '',
    loading: false,
    success: false,
  };

  info = [
    {
      key: 'only-registry',
      headline: 'Solo registro',
      content: <Typography component="p">Solo harás la inscripción en el torneo. Estarás desaprovechando una ocasión
        de
        oro para disfrutar de un alojamiento en grandes condiciones y con mínimas gestiones.</Typography>
    }
    ,
    {
      key: 'half-board-1',
      headline: '1 día media pensión',
      content: <Typography component="p">Un día a media pensión. Esto incluye cena, alojamiento y desayuno.</Typography>
    },
    // {
    //   key: 'half-board-2',
    //   headline: '2 noches media pensión',
    //   content: <Typography component="p">Dos noches a media pensión. Esto incluye cama, desayuno y una de estas dos:
    //     comida o cena.</Typography>

    // },
    // {
    //   key: 'half-board-meal',
    //   headline: '1 día media pensión + 1 comida extra',
    //   content: <Typography component="p">Un día a media pensión. <br /><br /> Cena + Alojamiento + Desayuno + Comida.</Typography>
    //
    // },
    {
      key: 'full-board-1',
      headline: '1 día pensión completa',
      content: <Typography component="p">Un día a pensión completa. <br /><br /> Comida + Cena + Alojamiento + Desayuno.</Typography>

    },
    // {
    //   key: 'full-board-2',
    //   headline: '2 noches pensión completa',
    //   content: <Typography component="p">Dos noches a pensión completa. Esto incluye cama, desayuno, comida y cena.
    //     Aunque quizá no en ese orden.</Typography>

    // },
    {
      key: 'full-board-meal',
      headline: '1 día pensión completa + 1 comida extra',
      content: <Typography component="p">Una pensión completa y una comida a mayores. <br/><br /> Comida + Cena + Alojamiento + Desayuno + Comida</Typography>

    },
    {
      key: 'default',
      headline: 'Elige tu opción',
      content: <Typography component="p">No queremos convencerte de nada, pero nuestras ofertas de alojamiento son
        espectaculares.</Typography>

    }
  ];

  saveOptions = (key) => (values) => {
    // [...new Set([...arr1,...arr2])]
    this.setState({form: {...this.state.form, ...{[key]: values}}})
  };

  getStepContent = (step, withHotel) => {
    const stepToAvoid = 5;
    const steps = [
      <StartingInfo />, //step 0
      <InputContactData choiceHandler={this.saveOptions('contactData')} selectedOption={this.state.form.contactData || null}/>, //step 1
      <ChooseDates choiceHandler={this.saveOptions('dates')} selectedOption={this.state.form.dates || null}/>, //step 2
      <ChooseOptions choiceHandler={this.saveOptions('boarding')} options={this.info} selectedOption={this.state.form.boarding || null}/>, //step 3
      <InputParticipants choiceHandler={this.saveOptions('participants')} participants={this.state.form.participants || {staff:1,players:15}}/>, //step 4
      <ChooseHotels choiceHandler={this.saveOptions('hotel')} 
        selectedBoarding={this.state.form.boarding }
        selectedHotel={this.state.form.hotel } 
        boarding={this.info.filter(e => e.key === this.state.form.boarding)[0]}
        participants={this.state.form.participants}/>, //step 5 maybe. We filter this out if !withHotel
      <EndingInfo filledData={this.state.form} />, //step 6 - 5
    ]
      .filter((element, index) => index !== stepToAvoid || (index === stepToAvoid && withHotel));
    return steps[step] || 'Unknown step'
  };

  hotelNeeded = () => (
    this.state.form.hasOwnProperty('boarding') 
    && this.state.form.boarding.hasOwnProperty('key') 
    && this.state.form.boarding.key !== 'only-registry');

  handleNext = () => {
    const {activeStep} = this.state;
    const withHotel = this.hotelNeeded();
    const steps = getSteps(withHotel);
    this.setState({
      activeStep: this.state.activeStep + 1,
      // currentOption,
    });
    if (activeStep === steps.length - 1){
      const v = this.state.form;
      const form =  {
        "person": {
          "name": v.contactData.name, 
          "phone": v.contactData.phone, 
          "email": v.contactData.email
        },
        "team": {
          "name": v.contactData.team,
          "city": v.contactData.city
        },
        "turnOption": v.dates.key,
        "turnName": v.dates.headline,
        "boardingOption": v.boarding.key,
        "boardingName": v.boarding.headline,
        "staffQuantity": v.participants.staff,
        "playerQuantity": v.participants.players,
        "hotelOption": v.hotel.name,
        "hotelPrice": v.hotel.price,
        "hotels":v.hotel.hotels,
        "amountProposed": 100 + (v.participants.staff + v.participants.players) * v.hotel.price,
        "comments": "v1"
      };

      console.log('###Sending: ', form);
      this.loading=true;
      this.props.mutate({
        variables: { registry: form }
      })
      .then((data) => {this.setState({loading: false, success: true}); console.log('response', data, this.state, this)})
      .catch((err) => {this.setState({loading: false, success: false}); console.log('error', err, this.state, this)})
    }
    // window.location.hash = '#step'+(activeStep)
  };

  handleBack = () => {
    this.setState({
      activeStep: this.state.activeStep - 1,
    })
    // window.location.hash = '#step'+(this.state.activeStep - 1)
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    })
  };

  hasContactData = (c) => {
    //https://stackoverflow.com/questions/46155/how-can-you-validate-an-email-address-in-javascript
    function validateEmail(email) {
      // eslint-disable-next-line 
      // noinspection RegExpRedundantEscape
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    }
    // //https://stackoverflow.com/a/29767609/3235278
    // function validatePhone(phone) {
    //   // var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    //   var re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
    //   return re.test(phone.toLowerCase());
    // }

    return c['name']
    && !isNaN(Number.parseInt(c['phone'], 10))
    && validateEmail(c['email'])
    && c['team']
    && c['city']
  };

  render () {
    const {classes} = this.props;
    const withHotel = this.hotelNeeded();
    const steps = getSteps(withHotel);
    const {activeStep} = this.state;

    const enableNextButton = activeStep === 0 
    || (activeStep === 1 && this.state.form.hasOwnProperty('contactData') && this.hasContactData(this.state.form.contactData))
    || (activeStep === 2 && this.state.form.hasOwnProperty('dates')) 
    || (activeStep === 3 && this.state.form.hasOwnProperty('boarding'))
    || (activeStep === 4 && this.state.form.hasOwnProperty('participants')) 
    || (withHotel && activeStep === steps.length -2 && this.state.form.hasOwnProperty('hotel'))
    || (activeStep === steps.length -1 )
    ;
      // this.state.activeStep === 3 && !this.state.form.hasOwnProperty('participants') ||
      // this.state.activeStep === 4 && !this.state.form.hasOwnProperty('hotel') ||
      // this.state.activeStep === 5 && !this.state.form.hasOwnProperty('contactData');

    return (
      <div className={classes.root}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((label, index) => {
            return (
              <Step key={label} id={'step'+index}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  {/* <Typography> */}
                  {this.getStepContent(index, withHotel)}
                  {/* </Typography> */}
                  <div className={classes.actionsContainer}>
                    <div>
                      {activeStep !== 0 && 
                      <Button
                        disabled={activeStep === 0}
                        onClick={this.handleBack}
                        className={classes.button}
                      >
                        Volver
                      </Button>
                      }
                      <Button
                        raised
                        color="primary"
                        onClick={this.handleNext}
                        className={classes.button}
                        disabled={!enableNextButton}
                      >
                        {activeStep === steps.length - 1 ? 'Confirmar' : activeStep === 0 ? 'Empezar' : 'Siguiente'}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            )
          })}
        </Stepper>
        {/*{console.log('rendering state',this.state)}*/}
        {(activeStep === steps.length && this.state.loading ) && (
                    <Paper square elevation={0} className={classes.resetContainer}>
                    <Typography className={classes.info}>Cargando...
                    </Typography>
                  </Paper>
        )}
        {(activeStep === steps.length && !this.state.loading && !this.state.success) && (
                    <Paper square elevation={0} className={classes.resetContainer}>
                    <Typography className={classes.info}>
                    Ha ocurrido un error. Inténtalo de nuevo o ponte en contacto con Balumatravel, agencia oficial de Arousa Fútbol 7. Sus datos de contacto son:<br />
                      <Phone className={classes.icon} /><a href="tel://986531907">986 531 907</a><br />
                      <Email className={classes.icon} /><a href="mailto://info@balumatravel.com">info@balumatravel.com</a><br /><br />
                      Su horario es de lunes a Viernes de 10 a 13:30 y de 16:30 a 20:30. Los Sábados de 10 a 13:30
                    </Typography>
        
                    <Button onClick={this.handleReset} className={classes.button}>
                      Salir
                    </Button>
                  </Paper>
        
        )}
        {(activeStep === steps.length && !this.state.loading && this.state.success) && (
          <Paper square elevation={0} className={classes.resetContainer}>
            <Typography className={classes.info}>Has confirmado tu registro. Los siguientes pasos del proceso de inscripción son:</Typography>

            <List className={classes.list}>
              <ListItem>
                <ListItemText primary="Contacto"
                              secondary={
                                <span style={{textAlign:'justify', display: 'inline-block'}}>Nos ponemos en contacto contigo y confirmamos la cantidad a pagar</span>
                              }/>
              </ListItem>
              <ListItem>
                <ListItemText primary="Pago"
                              secondary={
                                <div style={{textAlign:'justify', display: 'inline-block'}}>Debes hacer dos transferencias y nosotros confirmaremos su recepción.<br /><br />
                                Los 100€ de la inscripción se ingresarán en el número de cuenta: <br />
                                <span style={{fontWeight: 'bold'}}>IBAN: ES45 2080 5174 9630 4000 4238</span><br /><br />
                                La cantidad correspondiente al alojamiento se ingresará en un número de cuenta que os proporcionará BALUMA.
                                </div>
                              }/>
              </ListItem>
              <ListItem>
                <ListItemText primary="Confirmación" secondary={
                              <span style={{textAlign:'justify', display: 'inline-block'}}>Volveremos a contactar contigo para confirmar que la inscripción se ha completado.</span>
                            }/>
              </ListItem>
            </List>
            <Typography className={classes.info}>
              Os recordamos los datos de contacto de BALUMA TRAVEL, agencia oficial de Arousa Fútbol 7. Ante cualquier duda, consulta o demanda de otros servicios, podéis contactar con ellos en:<br />
              <Phone className={classes.icon} /><a href="tel://986531907">986 531 907</a><br />
              <Email className={classes.icon} /><a href="mailto://info@balumatravel.com">info@balumatravel.com</a><br /><br />
              Su horario es de lunes a Viernes de 10 a 13:30 y de 16:30 a 20:30. Los Sábados de 10 a 13:30
            </Typography>

            <Button onClick={this.handleReset} className={classes.button}>
              Salir
            </Button>
          </Paper>
        )}
      </div>
    )
  }
}

VerticalLinearStepper.propTypes = {
  classes: PropTypes.object,
};

const submitRepository = gql`
mutation addRegistry($registry: RegistryInput!) {
  addRegistry(registry: $registry) {
    person {
      id
      name
    }
    team {
      id
      name
    }
    boardingOption
    boardingName
    staffQuantity
    playerQuantity
    hotelOption
    hotelPrice
    hotels
    amountProposed
    comments
  }
}
`;

export default graphql(submitRepository)(withStyles(styles)(VerticalLinearStepper))



// WEBPACK FOOTER //
// ./src/components/VerticalLinearStepper.jsx